export const TERM_SUGGESTION_OUTCOME = {
  QUEUED: 'queued',
  REFRESHED: 'refreshed',
  SKIPPED: 'skipped',
} as const;

export type TermSuggestionOutcome =
  (typeof TERM_SUGGESTION_OUTCOME)[keyof typeof TERM_SUGGESTION_OUTCOME];

export const TERM_SUGGESTION_SKIPPED_REASON = {
  ALREADY_EXISTS: 'already_exists',
  PREVIOUSLY_REJECTED: 'previously_rejected',
  DUPLICATE_IN_REQUEST: 'duplicate_in_request',
} as const;

export type TermSuggestionSkippedReason =
  (typeof TERM_SUGGESTION_SKIPPED_REASON)[keyof typeof TERM_SUGGESTION_SKIPPED_REASON];

export interface TermSuggestionPayloadTerm {
  key: string;
}

export interface TermSuggestionPayload {
  origin: string;
  terms: TermSuggestionPayloadTerm[];
}

export interface TermSuggestionResult {
  index: number;
  key: string;
  outcome: TermSuggestionOutcome;
  reason?: TermSuggestionSkippedReason;
  suggestionId?: string;
}

export interface TermSuggestionResponse {
  results: TermSuggestionResult[];
  totals: {
    queued: number;
    refreshed: number;
    skipped: number;
  };
  createdTermSuggestions: number;
}

export const TERM_SUGGESTION_SEND_STATUS = {
  ACKNOWLEDGED: 'acknowledged',
  RETRYABLE: 'retryable',
  CIRCUIT_BROKEN: 'circuitBroken',
} as const;

export type TermSuggestionSendStatus =
  (typeof TERM_SUGGESTION_SEND_STATUS)[keyof typeof TERM_SUGGESTION_SEND_STATUS];

export interface TermSuggestionSendResult {
  status: TermSuggestionSendStatus;
}

export interface ReversTranslateToken {
  accessToken: string;
  idToken: string;
}
